export const watchNavbarCollapse = () => {
	const navbar = document.getElementById('main-nav');
	const navbarCollapse = document.getElementById('navbar-collapse');
	navbarCollapse.addEventListener(
		'show.bs.collapse',
		() => (navbar.dataset.drawerExpanded = true)
	);
	navbarCollapse.addEventListener('hide.bs.collapse', () => {
		navbar.dataset.drawerExpanded = false;
		// prevent navbar animation glitch
		document.documentElement.dataset.scrollDirection = 'up';
	});
};
